import React from 'react';
import styled, { keyframes } from 'styled-components';
import { mapping } from './assets';

const animation = keyframes`
  0% {
    transform: translateX(-100px);
  }
  50% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100px);
  }
`;

const reverseAnimation = keyframes`
  0% {
    transform: translateX(100px);
  }
  50% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(100px);
  }
`;

const FogImg = styled.img`
  position: absolute;
  bottom: -10%;
  width: 50%;
  height: auto;
  will-change: transform;
  pointer-events: none;
  z-index: 100;
`;

const LeftTopFog = styled(FogImg)`
  position: absolute;
  left: 0;
  width: 45%;
  animation: ${animation} 7000ms infinite ease-in-out;
  z-index: 110;
`;

const LeftBottomFog = styled(FogImg)`
  position: absolute;
  left: 0;
  animation: ${animation} 7000ms 1000ms infinite ease-in-out;
`;

const RightTopFog = styled(FogImg)`
  position: absolute;
  right: 0;
  animation: ${reverseAnimation} 7000ms infinite ease-in-out;
  z-index: 110;
`;

const RightBottomFog = styled(FogImg)`
  position: absolute;
  right: 0;
  animation: ${reverseAnimation} 7000ms 1000ms infinite ease-in-out;
`;

export const Fog: React.FC = () => (
  <>
    <LeftTopFog src={mapping['left-top']} />
    <LeftBottomFog src={mapping['left-bottom']} />
    <RightTopFog src={mapping['right-top']} />
    <RightBottomFog src={mapping['right-bottom']} />
  </>
);
